import { RaceDiagnostics, sanitiseDiagnosticValue } from './race-diagnostics.js';

/** Both export paths use the same credential-redacting report. */
export function createDiagnosticReport(diagnostics: RaceDiagnostics, replay: unknown) {
  return { runtime: diagnostics.export(), replay: sanitiseDiagnosticValue(replay) };
}

export function downloadDiagnosticReport(report: ReturnType<typeof createDiagnosticReport>): void {
  const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `nightshift-diagnostics-${report.runtime.generatedAt}.json`;
  try {
    document.body.append(anchor);
    anchor.click();
  } finally {
    anchor.remove();
    // Leave the object URL alive until the browser has consumed the download.
    // This lifetime must outlive race teardown and menu navigation.
    window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
  }
}
